export const PUSHER_EVENT_NAME = "App\\Events\\WhatsApp\\UniverseWaEvent"
export const PUSHER_EVENT_WA_INFO = "App\\Events\\WhatsApp\\UniverseWaInfoEvent"
export const PUSHER_EVENT_ENDSTATUS = "App\\Events\\WhatsApp\\EndConversationEvent"
export const PUSHER_EVENT_ACTIVE = "App\\Events\\WhatsApp\\StartConversationEvent"
export const PUSHER_EVENT_MESSAGES_STATUS = "App\\Events\\WhatsApp\\MessagesStatus"
export const LIMIT_MESSAGES = 30;
export const LIMIT_CONVERSATIONS = 50;
export const LIMIT_TEMPLATES = 20;
export const ENC_STORAGE_USER_KEY = "uwa-user";
export const SESS_STORAGE_USER_KEY = "uwa-activeTab";
export const BASE_URL =import.meta.env.VITE_BASE_URL;
export const S3_URL =import.meta.env.VITE_S3_URL;
export const BASE_URL_API =import.meta.env.VITE_BASE_URL+import.meta.env.VITE_SUB_BASE_URL+import.meta.env.VITE_API_VERSION;
export const IMG_PATH_PLACEHOLDER = new URL("https://universe-public.s3.ap-southeast-2.amazonaws.com/user.png")
export const IMG_SYSTEM_PLACEHOLDER = new URL("https://universe-public.s3.ap-southeast-2.amazonaws.com/system_icon.png")

export const UNIVERSE_WA_EVENT = 'WhatsApp\\UniverseWaEvent';
export const UNIVERSE_WA_INFO_EVENT = 'WhatsApp\\UniverseWaInfoEvent';
export const UNIVERSE_START_CONVERSATION_EVENT = 'WhatsApp\\StartConversationEvent';
export const UNIVERSE_END_CONVERSATION_EVENT = 'WhatsApp\\EndConversationEvent';
export const UNIVERSE_MESSAGE_STATUS_EVENT = 'WhatsApp\\MessagesStatus';
export const UNIVERSE_WA_SESSION_EVENT = 'WhatsApp\\UniverseWhatsAppSession';
